import * as React from "react";
import {CSSProperties} from "react";

interface ComponentProps {
	/**
	 * Custom style.
	 */
	style?: CSSProperties
}

type Props = ComponentProps

export default class SectionSeparator extends React.PureComponent<Props, {}> {
	render() {
		return (
			<div className="c-section-separator" style={this.props.style}/>
		);
	}
}